import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-white px-4 py-16 md:py-20" data-id="element-95" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-2xl rounded-2xl border border-line bg-sand px-7 py-12 text-center shadow-soft md:px-12" data-id="element-96" data-mp="9umggs3ido7a">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-white text-sage shadow-soft" data-id="element-97" data-mp="euh5sr7my5q8">
          <ShieldCheckIcon className="h-8 w-8" strokeWidth={1.6} aria-hidden="true" data-id="element-98" data-mp="jsaebqwevbto" />
        </div>
        <h2 className="text-2xl font-bold tracking-tight text-petrol md:text-3xl" data-id="element-99" data-mp="nsb4u9wsbdh3">
          30 giorni per provarlo con calma
        </h2>
        <p className="mt-5 leading-relaxed text-muted" data-id="element-100" data-mp="xjntytr77pjf">
          Scarica tutto, stampa le schede, porta le sequenze in sala e osserva come rispondono le tue allieve. Se dopo
          trenta giorni senti che non ti ha semplificato il lavoro, scrivici una riga e ti rimborsiamo per intero — e
          tieni comunque tutti i file, bonus compresi.
        </p>
      </Reveal>
    </section>;
}